module.exports = __webpack_public_path__ + "media/images/banner/discovery_desktop-499837f58778caac86b1f1fd4cf14a12.png";